document.addEventListener('DOMContentLoaded', function(event) {
    document.getElementById("tab-section-features").onmousemove = e => {
      for(const card of document.getElementsByClassName("card-feature")) {
        const rect = card.getBoundingClientRect(),
              x = e.clientX - rect.left,
              y = e.clientY - rect.top;
  
        card.style.setProperty("--mouse-x", `${x}px`);
        card.style.setProperty("--mouse-y", `${y}px`);
      };
    }
    
    var allButtons = document.querySelectorAll('.card-feature');
    var allCards = document.querySelectorAll('.feature-main-image');
  
    function setCardActive(id) {
      var elCard = `.feature-main-image[data-feature="${id}"]`;
      var card = document.querySelector(elCard);
  
      if (card.classList.contains('active')) return;
  
      if(card.dataset.video) {
        console.log('true inside');
        var video = card.querySelector('video');
        video.currentTime = 0.01; 
        video.play(); 
      } 
  
      card.style.setProperty('--pointer-opacity', '1');
      card.classList.add('active');
  
      allButtons.forEach((el, index) => {
        if(index == id) {
          el.classList.add('active');
        } else {
          el.classList.remove('active');
        }
      });
      allCards.forEach((el, index) => {
        if(index != id) {
          el.style.setProperty('--pointer-opacity', '0');
          el.classList.remove('active');
        }
      });
      
    }
  
  
    setCardActive(0);
  
    allButtons.forEach((el, index) => {
      
      
      if(window.matchMedia("(pointer: coarse)").matches) {
        // touchscreen
        el.addEventListener("click", (event) => {
          console.log('coarse');
          setCardActive(index);
        });
      } else {
        el.addEventListener("mouseover", (event) => {
          console.log('no coarse');
          setCardActive(index);
        });
      }
    });

    
  });